module.exports = __webpack_public_path__ + "d8e913c9efd119b6784802ab55ad9c47.svg";